<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('table_label_search')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot></slot>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_amzPurchaseStatus') || '单据状态'"
            >
              <dict-select
                v-model="form.listAmzPurchaseStatus"
                url="/sys/common/dict/system"
                :body="{ dictType: 'amzPurchaseStatus' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width: 100%"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_amzPurchaseNo') || '采购单号'">
              <el-input
                v-model="form.amzPurchaseNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_salesPerson') || '业务开发'">
              <dict-select
                v-model="form.listSalesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_buyer') || '采购跟单'">
              <dict-select
                v-model="form.listBuyerCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_skuSalesChannel') || '产品类型'"
            >
              <dict-select
                v-model="form.skuSalesChannel"
                url="/sys/common/dict/system"
                :body="{ dictType: 'skuSalesChannel' }"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_orderSource') || '订单合同名称（甲方）'"
            >
              <dict-select
                v-model="form.listOrderSource"
                url="/master/common/dict/biz"
                :body="{ dictType: 'orderSource' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_importanceLevel') || '重要级别'"
            >
              <dict-select
                v-model="form.listImportanceLevel"
                url="/master/common/dict/biz"
                :body="{ dictType: 'importanceLevel' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('form_label_purchaseDate') || '下单日期'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.purchaseDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.purchaseDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_quotedMethod') || '报价方式'">
              <dict-select
                v-model="form.listQuotedMethod"
                url="/sys/common/dict/system"
                :body="{ dictType: 'quotedMethod' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('form_label_totalAmount') || '总采购金额'"
              >
                <br />
                <el-col :span="8">
                  <el-input-number
                    v-model="form.totalAmountStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  />
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    v-model="form.totalAmountEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  />
                </el-col>
                <el-col :span="7">
                  <dict-select
                    v-model="form.currencyUnit"
                    url="/master/common/dict/biz"
                    :body="{ dictType: 'currencyUnit' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    filterable
                    clearable
                    style="width:100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('form_label_deliveryDate') || '交货日期'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_scm') || '执行工厂'">
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/scmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_orderScm') || '名义工厂'">
              <dict-select
                v-model="form.listOrderScmCode"
                url="/master/common/dict/scmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_settlementFactory') || '结算工厂'"
            >
              <dict-select
                v-model="form.listSettlementFactory"
                url="/master/common/dict/scmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_createDate') || '创建时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_submitTime') || '提交时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.submitTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.submitTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_reviewTime') || '审核时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.reviewTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.reviewTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_amzFirstDemandNo') || '新品首单需求单号'">
              <el-input
                v-model="form.amzFirstDemandNo"
                :placeholder="$l('tips_input_amzPurchaseNo') || '请输入新品首单需求单号...'"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = { keyword: '', listAmzPurchaseStatus: ['N', 'Y', 'S', 'R'] }
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()

    const _this = this
    this.$eventBus.$on('awsBiz-ftyPurchase-list-reload', () => _this.query())
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
